import { HttpClient } from "@angular/common/http";
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { Injectable } from "@angular/core";
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { Observable } from "rxjs";
import { ISetup } from "../models/device.interface";

@Injectable({
  providedIn: 'root'
})
export class SetupService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}Setup`


  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  listSetupsActiveByCompany(companyId: string): Observable<ResponseDefault<ISetup[]>> {
    return this.http.get<ResponseDefault<ISetup[]>>(`${this.apiUrl}/GetActiveSetupsByCompany/${companyId}`);
  }
}
